module.exports = __webpack_public_path__ + "img/parallelLogo.8dd16a0f.png";